import React from 'react';
import GlobalLayout from './GlobalLayout';
import WillItBend from './WillItBend';

const Dashboard = () => {
    return (
        <GlobalLayout>
            <WillItBend />
        </GlobalLayout>
    );
};

export default Dashboard;